
import { FoodList } from "../FoodList/FoodList";

export function Breakfast() {
  return <FoodList category="Breakfast" />;
}
